import React from "react"
import autobind from "class-autobind"
import { TextField } from "material-ui"
import strings from "../../../localization/strings"
import * as utils from "../../../helpers/utils"
import * as api from "../../../api"
import AccountStore from "../../../stores/AccountStore"
import{transformPhoneNumber} from "./IVRNumberChip"

interface IProps {
    style?: React.CSSProperties
    phoneNumber: string
    disabled?: boolean
    existingNumbers?: string[]
    handleChange(phoneNumber: string, isValidate: boolean)
}
interface IState {
    phoneNumber: string
    error: string
}



export default class IVRNumberText extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            phoneNumber: props.phoneNumber ? transformPhoneNumber(props.phoneNumber) : "",
            error: props.phoneNumber ? "" : strings.This_field_is_required
        }
        autobind(this)
    }

    async handleChange() {
        const isValidate = await this.checkValidate()
        this.props.handleChange(this.state.phoneNumber.trim(), !isValidate)
    }

    checkValidate(): Promise<boolean> {

        let phoneNumber = this.state.phoneNumber
        let isValidate = true
        const phone =  phoneNumber.replace(/\D/g, "")
        if (!phone) {
            this.setState({ error: strings.Number_is_required })
            isValidate = false
        }

       else if (!/^[+]?1?[\s\-.]?\(?\d{3}\)?[\s\-.]?\d{3}[\s\-.]?\d{4}$/.test(phoneNumber)) {
            this.setState({ error: strings.Phone_number_is_not_valid })
            isValidate = false
       }
        else if (this.props.existingNumbers && this.props.existingNumbers.find(item => item === phone)) {
            this.setState({ error: strings.Number_is_duplicated })
            isValidate = false
        }
        else {
            this.setState({ error: "" })
        }

        return new Promise(resolve =>
            !isValidate ?
                resolve(isValidate) :
                api.checkIVRPhoneNumberValidate(AccountStore.getCurrentAccount().Id, phone)
                    .then(res =>
                        resolve(res.data)
                    )
                    .catch(err =>
                        this.setState({ error: err.response.data.message })
                    )
        )
    }

    render() {
        console.log(this.props.existingNumbers,"existingNumbers")
        return (
            <TextField
                floatingLabelText={"IVR Phone Number"}
                style={this.props.style}
                value={this.state.phoneNumber}
                onChange={(e, value) => {
                        if (/^[+]?1?[\s\-.]?\(?\d{3}\)?[\s\-.]?\d{3}[\s\-.]?\d{4}$/.test(value)) {
                            this.setState({ phoneNumber: transformPhoneNumber(value) }, () => this.handleChange())
                        } else {
                            this.setState({ phoneNumber: value.trim() }, () => this.handleChange())
                        }
                }}
                errorText={this.state.error}
                errorStyle={{ position: "absolute", top: 70 }}
                disabled={this.props.disabled}
                onKeyPress={(e) => {
                    const cleaned = this.state.phoneNumber.replace(/\D/g, "")
                    if (cleaned.length >= 11 && e.key !== "Backspace" && e.key !== "Delete") {
                        e.preventDefault()
                    }
                }}
            />
        )
    }
}